import { defineMessages } from 'react-intl';

const definedMessages = defineMessages({
  bannerText: {
    id: 'app.shared.components.banner.bannerText',
    description: 'Body of the banner explaining the new TC',
    defaultMessage: 'A new Time Clock is here!',
  },
  bannerButtonText: {
    id: 'app.shared.components.banner.bannerButtonText',
    description: 'Call to action',
    defaultMessage: 'Check it out',
  },
});

export default definedMessages;



// WEBPACK FOOTER //
// ./src/components/shared/banner/i18n.js